module.exports = __webpack_public_path__ + "img/Group796.ca85e57a.png";